module.exports = __webpack_public_path__ + "img/药品柜.daccf7fa.jpg";